"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrapper = (0, _styled.default)('header')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      nav = _ref$theme.nav,
      space = _ref$theme.space;
  return _defineProperty({
    display: 'flex',
    position: 'relative',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '9.2rem',
    width: '100%',
    border: 'none',
    backgroundColor: colors[nav.backgroundColor],
    boxShadow: nav.boxShadow,
    padding: "0 ".concat(space.base)
  }, mediaQueries.xlarge, {
    padding: "0 ".concat(space.xlarge)
  });
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;